/**
 * `operationId` por COMANDO (no por entidad) para las entidades last-write-wins de catálogo
 * (product, category, brand, supplier).
 *
 * El servidor deduplica comandos por `(organization_id, entity_kind, operation_id)` en
 * `ops.applied_device_commands` de forma PERMANENTE (`apply_*_command` →
 * `ops.try_claim_device_command`). Si usáramos el id de la entidad como `operationId`, el primer
 * comando (alta) reclama esa clave y toda edición posterior choca: el RPC la devuelve como
 * "idempotente" y descarta el cambio en silencio. Resultado: el alta sincroniza, pero ninguna
 * edición vuelve a llegar al servidor.
 *
 * Combinando `id` + versión (`updatedAt`) cada edición distinta es un comando único que sí se
 * aplica, mientras que un reintento del mismo comando (misma versión) sigue deduplicándose. Si no
 * hubiera versión disponible se usa un sufijo único (el upsert por id del servidor es idempotente,
 * así que reaplicar es inofensivo). Módulo puro (sin dependencias nativas) para poder testearlo.
 */
export function buildCatalogSyncOperationId(id: string, payload: Record<string, unknown>): string {
  const fromCamel =
    typeof payload.updatedAt === 'string' && payload.updatedAt.trim().length > 0
      ? payload.updatedAt.trim()
      : null;
  const fromSnake =
    typeof payload.updated_at === 'string' && payload.updated_at.trim().length > 0
      ? payload.updated_at.trim()
      : null;
  const version = fromCamel ?? fromSnake ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${id}:${version}`;
}
